import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// type Props = {
//   label?: string | undefined;
//   type?: string | any;
//   // type: React.Dispatch<React.SetStateAction<number>> | React.Dispatch<React.SetStateAction<string>>;
//   className: string | undefined;
//   value?: string | number | undefined;
//   rowNo?: number | undefined;
//   onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
// };

export const CustomInput = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePasswordVisibility = () => {
    // console.log("Toggling password visibility");
    setShowPassword((prevShowPassword) => !prevShowPassword);
    // console.log("showPassword:", showPassword);
  };

  return (
    <TextField
      id="filled"
      label={props.label}
      type={showPassword ? "text" : props.type}
      color="primary"
      variant="filled"
      className={props.className}
      inputProps={{
        style: {
          fontFamily: "Inter",
          fontSize: "15px",
          fontWeight: 700,
        },
      }}
      onChange={props.onChange}
      value={props.value}
      required
      disabled={props.disabled}
      sx={{
        // input: { fontFamily: "Inter", fontSize: 18 },
        label: { fontSize: 13 },
      }}
      InputProps={{
        disableUnderline: true,
        endAdornment: (
          <InputAdornment position="end">
            {props.type === "password" && (
              <IconButton
                edge="end"
                onClick={handleTogglePasswordVisibility}
                // tabIndex="-1"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
    />
  );
};

export const CustomTextArea = (props) => {
  return (
    <TextField
      id="filled"
      color="primary"
      label={props.label}
      multiline
      rows={props.rowNo}
      variant="filled"
      className={props.className}
      inputProps={{
        style: {
          fontFamily: "Inter",
          fontSize: "15px",
          fontWeight: 700,
        },
      }}
      onChange={props.onChange}
      value={props.value}
      required
      //   sx={{
      //     input: { fontFamily: "Goudy", fontSize: 18 },
      //     label: { fontSize: 18 },
      //   }}

      InputProps={{ disableUnderline: true }}
    />
  );
};

export const CustomFile = (props) => {
  return (
    <TextField
      id="outlined-basic"
      type={props.type}
      color="primary"
      variant="outlined"
      className={props.className}
      inputProps={{
        style: { fontFamily: "Inter", fontSize: 18 },
      }}
      onChange={props.onChange}
      value={props.value}
      required
      //   sx={{
      //     input: { fontFamily: "Goudy", fontSize: 18 },
      //     label: { fontSize: 18 },
      //   }}
    />
  );
};
